export default __webpack_public_path__ + "static/media/memoria-gama-2024.f1fd5e7f.pdf";